import request from '@/plugins/admin_axios'
import requestEcommerce from '@/plugins/ecommerce_axios'

export const GetAllSchedulingByShoppingCartEcommerce = async (shoppingCartUUID) => {
  const response = await requestEcommerce.get(`atendimento/getByCarrinho/${shoppingCartUUID}`)
  return response.data
}

export const GetAllSchedulingByShoppingCart = async (shoppingCartUUID) => {
  const response = await request.get(`atendimento/getByCarrinho/${shoppingCartUUID}`)
  return response.data
}

export const CreateScheduling = async (schedulingData, side = 'ecommerce') => {
  const response = side == 'ecommerce' ? await requestEcommerce.post('/atendimento/createAtendimento/', schedulingData) : await request.post('/atendimento/createAtendimento/', schedulingData)
  return response.data
}

export const GetMeusAtendimentosVideo = async () => {
  const response = await requestEcommerce.get('/filas/fila_atendimentos/list/meus-atendimentos/')
  return response
}

export const CreateSchedulingAdmin = async (schedulingData) => {
  const response = await request.post('/atendimento/createAtendimentoAdmin/', schedulingData)
  return response.data
}

export const DeleteScheduling = async (schedulingUUID) => {
  const response = await request.post(`/atendimento/deleteAtendimento/`, { uuid: schedulingUUID })
  return response
}

export const ListTypesAtendimento = async () => {
  const response = await request.get('/atendimento/listModalidadesAtendimento/')
  return response.data
}

export const ListStatusAtendimento = async () => {
  const response = await request.get('/atendimento/listStatusAtendimento/')
  return response.data
}

export const RescheduleAtendimento = async (schedulingUUID, filial_uuid, data_hora_atendimento) => {
  const form = {
    "atendimento": schedulingUUID,
    "filial": filial_uuid,
    "data_hora": data_hora_atendimento
  }
  console.log(form);


  const response = await request.post(`/atendimento/reschedule/`, form)
  return response
}

export const GetScheduleHours = async (filial_uuid, data) => {
  const response = await request.post(`/filial/getHoursToSchedule/`,{ uuid: filial_uuid, data_inicial: data, data_final: data })
  return response
}

